"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _InfoDate = _interopRequireDefault(require("./InfoDate"));

var _methods = require("../../utils/methods");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var VerticalLine = function VerticalLine(_ref) {
  var columnRangeType = _ref.columnRangeType,
      startDatetime = _ref.startDatetime,
      columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      onDivisionSummary = _ref.onDivisionSummary;
  var items = [];
  var resultDate = (0, _methods.getDateTime)(startDatetime, columnRangeType, columnQuantity);
  var today = Date.parse(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));

  for (var i = 0; i < columnQuantity; i++) {
    var resultComparative = columnRangeType === 'DAY' ? Date.parse(new Date(resultDate[i].getFullYear(), resultDate[i].getMonth(), resultDate[i].getDate())) : null;
    items.push( /*#__PURE__*/_react["default"].createElement("div", {
      className: "division d-flex column",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_InfoDate["default"], {
      date: resultDate[i],
      columnRangeType: columnRangeType
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex align-items-end",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], {
      current: today === resultComparative,
      className: "hoverSection",
      onDivisionSummary: onDivisionSummary,
      columnSections: columnSections,
      key: "arrow-".concat(i)
    }))));
  }

  return items;
};

VerticalLine.propTypes = {
  onDivisionSummary: _propTypes["default"].any
};
VerticalLine.defaultProps = {
  onDivisionSummary: []
};
var _default = VerticalLine;
exports["default"] = _default;